import {
  ApartmentOutlined,
  ClusterOutlined,
  SettingOutlined,
  AppstoreOutlined,
  BuildOutlined,
} from '@ant-design/icons';

// Paleta cool-monocroma (ADN del rediseño). NO es la paleta de seguridad/severidad.
const PALETTE = [
  { color: '#0f172a', tint: '#e9eaf0' },
  { color: '#0055b3', tint: '#e7f0fa' },
  { color: '#1b4f72', tint: '#e8eef3' },
  { color: '#51607a', tint: '#eef1f4' },
  { color: '#3f5161', tint: '#eceff2' },
  { color: '#2c3e50', tint: '#eaedf0' },
];

const KNOWN_ICONS = {
  tipo_equipo: ApartmentOutlined,
  equipo: ApartmentOutlined,
  subsistema: ClusterOutlined,
  maquina: SettingOutlined,
  componente: AppstoreOutlined,
};

function hashKey(key) {
  const s = String(key || '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function typeStyle(nodeType, typesCatalog) {
  const key = nodeType || '__none__';
  const pal = PALETTE[hashKey(key) % PALETTE.length];
  const fromCatalog = (typesCatalog || []).find((t) => t.key === nodeType);
  const label = fromCatalog?.label || nodeType || 'Sin tipo';
  const Icon = KNOWN_ICONS[nodeType] || BuildOutlined;
  return { color: pal.color, tint: pal.tint, label, Icon };
}

const ESTADO_MAP = {
  operativo: { cls: 'ok', label: 'Operativo' },
  observacion: { cls: 'signal', label: 'En observación' },
  detenido: { cls: 'err', label: 'Detenido' },
};
const CRIT_MAP = {
  baja: { cls: 'ok', label: 'Baja' },
  media: { cls: 'signal', label: 'Media' },
  alta: { cls: 'warn', label: 'Alta' },
  critica: { cls: 'err', label: 'Crítica' },
};
const ESTADO_KEYS = ['estado', 'estado_operativo', 'status'];
const CRIT_KEYS = ['criticidad', 'crit'];

function attrsOf(node) {
  if (!node) return null;
  return node.attributes ?? node.raw?.attributes ?? null;
}
function pick(attrs, keys) {
  if (!attrs) return null;
  for (const k of keys) {
    const v = attrs[k];
    if (v != null && v !== '') return String(v).toLowerCase();
  }
  return null;
}

export function deriveEstado(node) {
  const v = pick(attrsOf(node), ESTADO_KEYS);
  return v ? ESTADO_MAP[v] || null : null;
}
export function deriveCriticidad(node) {
  const v = pick(attrsOf(node), CRIT_KEYS);
  return v ? CRIT_MAP[v] || null : null;
}
